import React from 'react';
import connect from "react-redux/es/connect/connect";
import withAuthorization from "../../../services/Authorization";
import {injectIntl} from "react-intl";
import RentalJourneyInfoModal from "./RentalJourneyInfoModal";
import PlanningTable from "../planningtable/PlanningTable";
import Constants from "../../../services/Constants";
import moment from 'moment';
import ManualRentalBookingModal from "./ManualRentalBookingModal";

class ParkPlanning extends React.Component {

  constructor(props) {
    super(props);
    this.state = {
      from: moment().format(Constants.DATE_FORMAT_API),
      to: moment().add(15, 'days').format(Constants.DATE_FORMAT_API)
    }
  }

  componentWillReceiveProps = (nextProps) => {
    if (nextProps.fetchRentalPark && nextProps.fetchRentalPark.rentalPark) {
      this.setState({rentalPark: nextProps.fetchRentalPark.rentalPark});
    }
  };

  fetchRentalPark = (page, size, from, to) => {
    this.props.dispatchFetchRentalPark({page, size, from, to});
  };

  onSelect = (rentalDetails) => {
    this.props.showModal({show:true, rentalDetails});
  };

  onModalClose = () => {
    this.props.showModal({show:false});
  };

  onDataUpdate = (page, size, from, to) => {
    this.setState({from, to});
    this.fetchRentalPark(page, size, from, to);
  };

  onManualBooking = (rentalDetails) => {
    this.props.showManualRentalBookingModal({show:true, rentalDetails});
  };

  onManualBookingClose = () => {
    this.props.showManualRentalBookingModal({show:false});
  };

  onManualBookingSave = (formData) => {
     const {rentalDetailsId, firstName, lastName, phone, from, to, ...rest} = formData;
    const body = {
      customerDetails:{
        firstName,
        lastName,
        phone,
        from,
        to,
      },
      ...rest
    };
    this.props.dispatchSaveManualBooking({body, from:this.state.from, to:this.state.to, rentalDetailsId});
  }


  onManualBookingDelete = (rentalDetailsId) => {
    const {from, to} = this.state;
    this.props.dispatchDeleteManualBooking({rentalDetailsId, from, to});
  }


  render() {
    const {fetchRentalPark: {loading, totalElements, showModal, showManualRentalBookingModal, rentalDetails, error = {}}} = this.props;
    const {rentalPark, from, to} = this.state;
    const errors = error.content || {};
    return (
      <div>
        <PlanningTable rentalPark={rentalPark} loading={loading} totalElements={totalElements}
                       from={from} to={to} errors={errors}
                       onSelect={this.onSelect} onDataUpdate={this.onDataUpdate} onManualBooking={this.onManualBooking}/>

        {rentalDetails && rentalDetails.rentingJourney && <RentalJourneyInfoModal visible={showModal} onModalClose={this.onModalClose} rentalDetails={rentalDetails}/>}
        {rentalDetails && rentalDetails.rentingCustomer && <ManualRentalBookingModal backendErrors={error} visible={showManualRentalBookingModal} onSave={this.onManualBookingSave} onDelete={this.onManualBookingDelete} onModalClose={this.onManualBookingClose} rentalDetails={rentalDetails} />}
      </div>
    )
  }
}

const mapStateToProps = state => ({
  fetchRentalPark: state.fetchRentalPark
});

const mapDispatchToProps = dispatch => ({
  dispatchFetchRentalPark: (params) => dispatch({type: 'FETCH.RENTAL_PARK.REQUEST', params}),
  showModal: (params) => dispatch({type: 'SHOW.RENTING_JOURNEY_MODAL', params}),
  showManualRentalBookingModal: (params) => dispatch({type: 'SHOW.MANUAL_RENTAL_BOOKING_MODAL', params}),
  dispatchSaveManualBooking: (params) => dispatch({type: 'SAVE.MANUAL_RENTAL_BOOKING.REQUEST', params}),
  dispatchDeleteManualBooking: (params) => dispatch({type: 'DELETE.MANUAL_RENTAL_BOOKING.REQUEST', params}),
});

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(withAuthorization(injectIntl(ParkPlanning), ['DUI_ADMIN', 'DUI_SERVICE_ADVISOR']));
